module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Home/Toilet-7879836a4277d640816d15dc5607fa73.svg";